export const PROMISE_STATUS = {
  PENDING: 'pending',
  FULFILLED: 'fulfilled',
  REJECTED: 'rejected',
};

export const ENTITIES_TYPEAHEAD_PAGE_SIZE = 100;

export const TIMEZONE_OFFSET_HEADER = 'X-Kizen-Filter-Timezone-Offset';
